<script>
import { required } from 'vuelidate/lib/validators'

export default {
	props: {
		event: {
			type: Object,
			required: true
		}
	},
	data() {
		return {

		}
	},
	methods: {
		formatSeverityText (severity) {
			let severityColor = {
				"high": "color:#FF6780",
				"medium": "color:#FFC60B",
				"low": "color:#4DD8A8"
			}
			return severityColor[severity]
		},
		formatTypeText (severity) {
			let severityColor = {
				"Malware": "color:#FF6780",
				"medium": "color:#FFC60B",
				"low": "color:#4DD8A8"
			}
			return severityColor[severity]
		},
		formatAction (action) {
			let actionColor = {
				"DETECTED": "color:rgb(26, 5, 214)",
				"BLOCKED_9": "color:#01AD00",
				"PREVENTED": "color:#01AD00"
			}
			return actionColor[action]
		},
		camelCaseToSentence (text) {
			const result = text.replace( /([A-Z])/g, " $1" )
			return result.charAt(0).toUpperCase() + result.slice(1)
		}
	}
}
</script>

<template>
	<div role="tablist" class="custom-accordionwitharrow">
		<a href="#" class="text-dark" v-b-toggle.collapse-general>
			<h5 class="mb-0">
				<feather type="chevron-down" class="align-middle"></feather>
				General
			</h5>
		</a>
		<b-collapse visible id="collapse-general">
			<div class="custom-control">
				<b>Event Type:</b>&nbsp;{{ camelCaseToSentence(event.ContentType).split('_').join(' ') }}
			</div> 
			<div class="custom-control">
				<b>Operation:</b>&nbsp;{{ camelCaseToSentence(event.Operation) }}
			</div> 
			<div class="custom-control">
			<b>Result Status:</b>&nbsp;
			<template v-if="['Success','Succeeded'].includes(event.ResultStatus)">
				<span style="color: green;">
					{{ event.ResultStatus }}
				</span>
			</template>
			<template v-else-if="['Fail','Failed'].includes(event.ResultStatus)">
				<span style="color: red;">
					{{ event.ResultStatus }}
				</span>
			</template>
			<template v-else>
				{{ event.ResultStatus }}
			</template>
			</div>
			<template v-if="event.LogonError !== undefined">
				<div class="custom-control">
					<b>Logon Error:</b>&nbsp;
					<span>
						{{ camelCaseToSentence(event.LogonError) }}
					</span>
				</div>
			</template>
	
			<div class="custom-control">
				<b>User Id:</b>&nbsp;{{ event.UserId }}
			</div> 

			<template v-if="event.UserName !== undefined">
				<div class="custom-control">
					<b>User Name:</b>&nbsp;
					<span>
						{{ event.UserName }}
					</span>
				</div>
			</template>

			<template v-if="event.AppName !== undefined">
				<div class="custom-control">
					<b>Application Name:</b>&nbsp;
					<span>
						{{ event.AppName }}
					</span>
				</div>
			</template>

			<template v-if="event.ClientApp !== undefined">
				<div class="custom-control">
					<b>Client App:</b>&nbsp;
					<span>
						{{ event.ClientApp }}
					</span>
				</div>
			</template>

			<template v-if="event.Browser !== undefined">
				<div class="custom-control">
					<b>Browser:</b>&nbsp;
					<span>
						{{ event.Browser }}
					</span>
				</div>
			</template>

			<template v-if="event.OperatingSystem !== undefined">
				<div class="custom-control">
					<b>Operating System:</b>&nbsp;
					<span>
						{{ event.OperatingSystem }}
					</span>
				</div>
			</template>

			<template v-if="event.intelligence !== undefined && event.intelligence.geoip !== undefined">
				<div class="custom-control">
					<b>Client IP:</b>&nbsp;
					<template v-if="event.intelligence.geoip.security.threat_level === 'low'">
						<span style="color: green;">
							{{ event.ClientIP }}
						</span>
					</template>
					<template v-else-if="event.intelligence.geoip.security.threat_level === 'medium'">
						<span style="color: orange;">
							{{ event.ClientIP }}
						</span>
					</template>
					<template v-else-if="event.intelligence.geoip.security.threat_level === 'high'">
						<span style="color: red;">
							{{ event.ClientIP }}
						</span>
					</template>
					<template v-else>
						{{ event.ClientIP }}
					</template>
				</div> 
			</template>
		</b-collapse>
		<template v-if="event.intelligence !== undefined && event.intelligence.geoip !== undefined">
			<br>
			<a href="#" class="text-dark" v-b-toggle.collapse-security>
				<h5 class="mb-0">
					<feather type="chevron-down" class="align-middle"></feather>
					Security
				</h5>
			</a>
			<b-collapse visible id="collapse-security">
				<div class="custom-control" v-if="event.intelligence.geoip.security.threat_level !== null">
					<b>Threat Level:</b>&nbsp;
					<template v-if="event.intelligence.geoip.security.threat_level === 'low'">
						<span style="color: green;">
							{{ event.intelligence.geoip.security.threat_level }}
						</span>
					</template>
					<template v-else-if="event.intelligence.geoip.security.threat_level === 'medium'">
						<span style="color: orange;">
							{{ event.intelligence.geoip.security.threat_level }}
						</span>
					</template>
					<template v-else-if="event.intelligence.geoip.security.threat_level === 'high'">
						<span style="color: red;">
							{{ event.intelligence.geoip.security.threat_level }}
						</span>
					</template>
					<template v-else>
						{{ event.intelligence.geoip.security.threat_level }}
					</template>
				</div> 
				<div class="custom-control">
					<b>Threat Types:</b>&nbsp;{{ event.intelligence.geoip.security.threat_types === null ? "N.A." : event.intelligence.geoip.security.threat_types.join(", ") }}
				</div> 	
				<div class="custom-control">
					<b>Is TOR Node:</b>&nbsp;{{ event.intelligence.geoip.security.is_tor ? "Yes" : "No"}}
				</div>
				<div class="custom-control">
					<b>Is Proxy:</b>&nbsp;{{ event.intelligence.geoip.security.is_proxy ? "Yes" : "No"}}
				</div> 	
				<div class="custom-control">
					<b>&nbsp;&nbsp;Proxy Type:</b>&nbsp;{{ event.intelligence.geoip.security.proxy_type === null ? "N.A." : event.intelligence.geoip.security.proxy_type }}
				</div> 	
				<div class="custom-control">
					<b>Is Crawler:</b>&nbsp;{{ event.intelligence.geoip.security.is_crawler ? "Yes" : "No"}}
				</div>
				<div class="custom-control">
					<b>&nbsp;&nbsp;Crawler Name:</b>&nbsp;{{ event.intelligence.geoip.security.crawler_name === null ? "N.A." : event.intelligence.geoip.security.crawler_name }}
				</div> 	
				<div class="custom-control">
					<b>&nbsp;&nbsp;Crawler Type:</b>&nbsp;{{ event.intelligence.geoip.security.crawler_type === null ? "N.A." : event.intelligence.geoip.security.crawler_type }}
				</div>
			</b-collapse>
			<br>
			<a href="#" class="text-dark" v-b-toggle.collapse-connection>
				<h5 class="mb-0">
					<feather type="chevron-down" class="align-middle"></feather>
					Connection
				</h5>
			</a>
			<b-collapse visible id="collapse-connection">
				<template v-if="event.intelligence.geoip.connection !== undefined">
					<div class="custom-control">
						<b>ASN:</b>&nbsp;{{ event.intelligence.geoip.connection.asn === undefined ? "N.A." : event.intelligence.geoip.connection.asn }}
					</div>
					<div class="custom-control">
						<b>ISP:</b>&nbsp;{{ event.intelligence.geoip.connection.isp === undefined ? "N.A." : event.intelligence.geoip.connection.isp }}
					</div>
				</template>
			</b-collapse>
		</template>
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>